import { LoadedPageContent } from '$components/common'
import { default as Timeclock } from '.'
import { RouteObject } from 'react-router-dom'

const basePath = '/time/timeclock'
export const timeclockRoutes: RouteObject[] = [
  {
    path: `${basePath}/staff-clocks`,
    element: (
      <LoadedPageContent title={'Staff Clocks'}>
        <Timeclock.StaffClocks.Component />
      </LoadedPageContent>
    ),
    loader: Timeclock.StaffClocks.Loader,
  },
  {
    path: `${basePath}/punches-by-staff`,
    element: (
      <LoadedPageContent
        title={'Punches By Staff'}
        customBottomLeftComponent="ExportReportSelect"
      >
        <Timeclock.PunchesByStaff.Component />
      </LoadedPageContent>
    ),
    loader: Timeclock.PunchesByStaff.Loader,
  },
]
